import Axios from "axios";
import { computeHmacSha256 } from "../utils/crypto";
import { DateTime } from "luxon";
import {
	clearLocalStorage,
	getLocalStorage,
	handleGetCookie
} from "../utils/commonUtil";

const axios = Axios.create({});

const serverUrl = process.env.REACT_APP_SERVER_URL;
const seckey = process.env.REACT_APP_SEC_KEY;

export const baseURL = `${serverUrl}`;

axios.defaults.timeout = 300000;

function getAuthData() {
	return getLocalStorage("auth") || handleGetCookie("auth") || null;
}

function isTestUser() {
	const auth = getAuthData();

	// ກໍລະນີ structure: auth.data.user.isTest
	if (auth?.data?.user?.isTest == 1) {
		return true;
	}

	// ກໍລະນີ structure: auth.user.isTest
	if (auth?.user?.isTest == 1) {
		return true;
	}

	// ກໍລະນີ structure: auth.isTest
	if (auth?.isTest == 1) {
		return true;
	}

	return false;
}

axios.interceptors.request.use(
	async function (config) {
		let token = getLocalStorage("auth")?.accessToken || null;

		const authRegister = getLocalStorage("authRegister")?.accessToken || null;

		if (authRegister) {
			token = authRegister;
			clearLocalStorage("authRegister");
		}

		if (!token) {
			token = handleGetCookie("auth")?.accessToken || null;
		}

		const dateTime = DateTime.now().setZone("Asia/Bangkok").toISO();

		// ຖ້າ user ເປັນ test user ໃຫ້ສົ່ງ header ໄປ nginx
		if (isTestUser()) {
			config.headers["X-Test-User"] = "ulaodev-test";
		}

		if (config.url?.startsWith("/token") || config.url?.startsWith("/export")) {
			const signa = dateTime + seckey;

			const mySignature = await computeHmacSha256(
				signa,
				process.env.REACT_APP_AVOID_TOKEN_KEY
			);

			config.headers["signature"] = mySignature;
			config.headers["createdtime"] = dateTime;

			if (config.url?.startsWith("/export")) {
				config.responseType = "blob";
			}
		} else {
			const signatureText = dateTime + seckey;
			const signature = await computeHmacSha256(signatureText, token || "");

			if (token) {
				config.headers["auth"] = `Bearer ${token}`;
			}

			config.headers["Access-Control-Allow-Credentials"] = true;
			config.headers["signature"] = signature;
			config.headers["createdtime"] = dateTime;

			if (typeof FormData !== "undefined" && config.data instanceof FormData) {
				// Let the browser add the multipart boundary automatically.
				delete config.headers["Content-Type"];
			} else if (config.url?.startsWith("/file/upload")) {
				config.headers["Content-Type"] = "multipart/form-data";
			} else {
				config.headers["Content-Type"] = "application/json";
			}
		}

		config.credentials = "same-origin";
		config.baseURL = baseURL;

		return config;
	},
	function (error) {
		return Promise.reject(error);
	}
);

axios.interceptors.response.use(
	(res) => {
		return res;
	},
	(error) => {
		if (error?.response?.status === 401) {
			console.log(error?.response);
			window.location.href = "/logout";
			return Promise.reject(error);
		}

		return Promise.reject(error);
	}
);

export default axios;